import classNames from 'classnames';

interface IconProps {
    className?: string | null;
}

function Surf({ className = null }: IconProps) {
    return (
        <div className={classNames(className)}>
            <svg
                width="128.6px"
                height="137px"
                viewBox="0 0 128.6 137"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <g>
                    <path
                        d="M128.6,112.6l-112.1,24.4L1.3,67.2C-5.1,37.9,13.5,8.9,42.8,2.6l6-1.3c29.3-6.4,58.2,12.2,64.6,41.5l15.2,69.9Z"
                        fill="#d6e3fe"
                    />
                    <path
                        d="M18,134.6L3.2,66.7C-2.9,38.6,15,10.6,43.2,4.5l6-1.3c28.2-6.1,56.1,11.8,62.2,40l14.8,67.9-108.2,23.5Z"
                        fill="none"
                        stroke="#5e8bd1"
                        strokeMiterlimit="10"
                        strokeWidth=".5"
                    />
                    <path
                        d="M19.5,132.2L5.2,66.3C-.7,39.2,16.5,12.4,43.6,6.5l6-1.3c27.1-5.9,53.9,11.4,59.8,38.5l14.3,65.9-104.3,22.7Z"
                        fill="none"
                        stroke="#5e8bd1"
                        strokeMiterlimit="10"
                        strokeWidth=".5"
                    />
                </g>
                <circle cx="55.2" cy="46.4" r="30.2" fill="#5e8bd1" />
                <path
                    d="M68.3,77.3c0,.2-.2.4-.4.5s0,0,0,0c-.3,0-.5-.2-.5-.5-.3-8.5-2.4-16.3-6.2-23.2-.1-.2,0-.5.2-.7.2-.1.5,0,.7.2,3.9,7,6,15,6.3,23.6Z"
                    fill="#5e8bd1"
                />
                <path
                    d="M68.2,84.3c0,1.1-.2,2.2-.3,3.2,0,.2-.2.4-.4.4s-.1,0-.2,0c-.3,0-.5-.3-.4-.5.1-1.1.2-2.1.3-3.2,0-.3.3-.5.5-.4.3,0,.5.3.4.5Z"
                    fill="#5e8bd1"
                />
                <path
                    d="M24.9,107.3c2.2-.5,2.6,1.5,4.8,1s1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1"
                    fill="none"
                    stroke="#5e8bd1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".5"
                />
                <path
                    d="M26.2,113.2c2.2-.5,2.6,1.5,4.8,1,2.2-.5,1.8-2.4,4-2.9s2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1"
                    fill="none"
                    stroke="#5e8bd1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".5"
                />
                <path
                    d="M27.5,119.2c2.2-.5,2.6,1.5,4.8,1s1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1,1.8-2.4,4-2.9,2.6,1.5,4.8,1"
                    fill="none"
                    stroke="#5e8bd1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".5"
                />
                <line
                    x1="62.7"
                    y1="97.3"
                    x2="69.7"
                    y2="95.7"
                    fill="none"
                    stroke="#5e8bd1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".5"
                />
                <path
                    d="M56.9,96.8c5.9-1.6,11.9-2.9,18.1-3.9"
                    fill="none"
                    stroke="#5e8bd1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".5"
                />
                <path
                    d="M51,101.6c2-4.7,7.3-8.8,14-10.2,7.7-1.7,15,.5,18.4,5"
                    fill="none"
                    stroke="#5e8bd1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".5"
                />
                <path
                    d="M53.7,40.3l11.8,54.1-4.2,1c-15.7-25.9-10.3-47.7-7.9-55.1s.3-.1.3,0Z"
                    fill="#d6e3fe"
                />
                <path
                    d="M65.7,94.1l-12.1-55.4s-11.6,25,7.5,57"
                    fill="none"
                    stroke="#5e8bd1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".5"
                />
                <path
                    d="M54.2,40.2l11.8,54.1,4.2-.8c3.5-30.1-10.4-47.7-15.7-53.4s-.3,0-.3.1Z"
                    fill="#d6e3fe"
                />
                <path
                    d="M65.8,94.5l-12.1-55.8s21,17.9,16.8,54.9"
                    fill="none"
                    stroke="#5e8bd1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".5"
                />
                <path
                    d="M61.3,53.5s6.6,11.3,6.5,24.3"
                    fill="none"
                    stroke="#5e8bd1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".5"
                />
            </svg>
        </div>
    );
}

export default Surf;
